// extracted by mini-css-extract-plugin
module.exports = {"header":"_7a3fb80146--header--w__Ss","tabs":"_7a3fb80146--tabs--Ymuz4"};